import { createRoute } from "utilities/flatRoutes/routes";
import { routes } from "utilities/routes";

/**
 * Flat route for the current user's own Internal User Details modal. Used by the avatar
 * "My Preferences" dropdown so the navigation carries previous-location state, letting the
 * modal return the user to the page they came from on close. The id is never in the URL —
 * it is resolved from UserInfoContext when the modal renders.
 */
export const myUserDetailsRoute = createRoute<undefined, { initialTab: string; upm: string }>(
    routes.internalUsers.myUserDetails,
    "My Preferences",
);
